import { Layout } from "antd";
import React from 'react'
import { Link, useLocation } from "react-router-dom";
import calendar from "../../../assets/images/NewIcons/calendar.svg";
import calendar_selected from "../../../assets/images/NewIcons/calendar_selected.svg";
import campaign from "../../../assets/images/NewIcons/campaign.svg";
import campaign_selected from "../../../assets/images/NewIcons/campaign_selected.svg";
import conversations from "../../../assets/images/NewIcons/conversations.svg";
import conversations_selected from "../../../assets/images/NewIcons/conversations_selected.svg";
import factcubes from "../../../assets/images/NewIcons/factcubes.svg";
import factcubes_selected from "../../../assets/images/NewIcons/factcubes_selected.svg";
import home from "../../../assets/images/NewIcons/home.svg";
import home_selected from "../../../assets/images/NewIcons/home_selected.svg";
import journey from "../../../assets/images/NewIcons/journey.svg";
import journey_selected from "../../../assets/images/NewIcons/journey_selected.svg";
import landing_page from "../../../assets/images/NewIcons/landing_page.svg";
import landing_page_selected from "../../../assets/images/NewIcons/landing_page_selected.svg";
import segments from "../../../assets/images/NewIcons/segments.svg";
import segments_selected from "../../../assets/images/NewIcons/segments_selected.svg";
import settings from "../../../assets/images/NewIcons/settings.svg";
import settings_selected from "../../../assets/images/NewIcons/settings_selected.svg";
import templates from "../../../assets/images/NewIcons/templates.svg";
import templates_selected from "../../../assets/images/NewIcons/templates_selected.svg";
import NewHeader from "../NewHeader";

import "./LeftSidebar.scss";


const EXCLUDED_ROUTES = [
    /^\/individualCampaign\/component\/\d+\/whatsapp\/journey\/\d+$/,
    /^\/individualCampaign\/component\/\d+\/email\/journey\/\d+$/,
    /^\/individualCampaign\/component\/\d+\/sms\/journey\/\d+$/,
    /^\/individualCampaign\/social-post\/\d+$/,
    /^\/individualCampaign\/sms\/\d+$/,
    /^\/individualCampaign\/email\/\d+$/,
    /^\/clickData\/email\/\d+$/,
    /^\/landingPages\/\d+$/,
    /^\/edit-template\/\d+$/,
    /^\/resetpassword+$/,
    /^\/addnewuserpassword+$/,
    /^\/forgot-password+$/
];

export default function LeftBar({ children, showHeader = true }) {
    const location = useLocation();
    const { pathname } = location;
    const items = [
        {
            name: "Home",
            url: "/",
            exact: true,
            icon: home,
            iconSelected: home_selected,
        },
        {
            name: "Calendar",
            url: "/MarketingCalendar",
            icon: calendar,
            iconSelected: calendar_selected,
        },
        {
            name: "Segments",
            icon: segments,
            iconSelected: segments_selected,
            url: "/segments",
        },
        {
            name: "Templates",
            url: "/templates",
            icon: templates,
            iconSelected: templates_selected,
        },
        {
            name: "Landing Pages",
            url: "/landing_pages",
            icon: landing_page,
            iconSelected: landing_page_selected,
        },
        {
            name: "Campaigns",
            url: "/campaign",
            icon: campaign,
            iconSelected: campaign_selected,
        },
        {
            name: "Journeys",
            url: "/journey",
            icon: journey,
            iconSelected: journey_selected,
        },
        {
            name: "Conversations",
            url: "/conversations",
            icon: conversations,
            iconSelected: conversations_selected,
        },
        {
            name: "FactCubes",
            url: "/factcube",
            icon: factcubes,
            iconSelected: factcubes_selected,
        },
        // {
        //     name: "FactCubes-Looker",
        //     url: "/factlooker",
        //     icon: factcubes,
        //     iconSelected: factcubes_selected,
        // },
    ];

    const isExcluded = EXCLUDED_ROUTES.some((pattern) => {
        if (pattern instanceof RegExp) {
            return pattern.test(pathname);
        }
        return false;
    });

    return (
        <>
            {showHeader && <NewHeader />}

            {!isExcluded ? (
                <div>
                    <div className="leftbar">
                        {/* // Please don't remove z-index. If modal is opened then sidebar should be clearly visible as per the requirement. */}
                        <Layout.Sider
                            width={200}
                            style={{
                                zIndex: 100,
                                boxShadow: "rgba(0, 0, 0, 0.05) 1px 1px 3px",
                                padding: "8px",
                            }}
                        >
                            <ul className="sidebar-list">
                                {items.map((item) => (
                                    <Link key={item.url} to={item.url}>
                                        <li
                                            className={`li-menu ${(item.exact ? pathname === item.url : pathname.includes(item.url)) ? "sidebar-active" : ""
                                                }`}
                                        >
                                            <img
                                                src={
                                                    (item.exact ? pathname === item.url : pathname.includes(item.url))
                                                        ? item.iconSelected
                                                        : item.icon
                                                }
                                                alt={item.name}
                                                style={{ width: 16 }}
                                            />
                                            <div className="ml-fix">{item.name}</div>
                                        </li>
                                    </Link>
                                ))}
                            </ul>
                            <hr style={{ width: "100%", margin: 8, marginBottom: 0 }} />
                            <Link
                                to="/settings"
                                className={`li-menu settings-link ${pathname.includes("/settings") ? "sidebar-active" : ""}`}
                                style={{
                                    height: "50px",
                                    width: "100%",
                                    textDecoration: "none",
                                    fontSize: 16,
                                }}
                            >
                                <img src={pathname.includes("/settings") ? settings_selected : settings} alt="gear" style={{ width: 18 }} />
                                <div className="ml-fix">Settings</div>
                            </Link>
                        </Layout.Sider>
                    </div>

                    <Layout className="site-layout">
                        <Layout.Content className="leftbar-content">
                            <div className="site-layout-background">{children}</div>
                        </Layout.Content>
                    </Layout>
                </div>
            ) : (
                children
            )}
        </>
    );
}
